import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  BokkzSbLogic,
  GiftTaxEntity,
  SbBerekening
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {NgIf} from "@angular/common";
import {Subscription} from "rxjs";
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-belasting',
  standalone: true,
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        NgIf,
        SharedUiAlertModule
    ],
  templateUrl: './belasting.component.html',
  styleUrl: './belasting.component.css'
})
export class BelastingComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  @Input() public validaties: any;
  private giftTaxEntitySubscription: Subscription | undefined;
  private sbBerekeningSubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public sbBerekening = {} as SbBerekening;
  public sbBerekeningFg = {} as FormGroup;
  public percentageEersteSchijf = <string>{}
  public percentageTweedeSchijf = <string>{}
  public lengteEersteSchijf = <string>{}
  public lengteTweedeSchijf = <string>{}
  public hasOnroerendeZaken = false;
  public aantalValidatiesValue = {} as number;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    public sbService: BokkzSbLogic,
    private fb: FormBuilder) {
    this.sbBerekeningFg = this.fb.group<SbBerekening>({
      totaalBedragContanten: null as unknown as number,
      totaalBedragEffecten: null as unknown as number,
      totaleWaardeGeschonkenOnroerendeZaken: null as unknown as number,
      totaalGeschonkenOndernemingsVermogen: null as unknown as number,
      totaalVrijgesteldOndernemingsVermogen: null as unknown as number,
      totaleWaardeGeschonkenApv: null as unknown as number,
      totaleWaardeGeschonkenPu: null as unknown as number,
      totaleWaardeGeschonkenRoerendeZaken: null as unknown as number,
      totaleWaardeSchuldigErkenning: null as unknown as number,
      totaleWaardeKwijtscheldingen: null as unknown as number,
      totaleWaardeVruchtgebruik: null as unknown as number,
      totaleWaardeOverigeSchenkingen: null as unknown as number,
      totaleSchenking: null as unknown as number,
      totaleVrijstellingen: null as unknown as number,
      eerderGebruikteVrijstellingen: null as unknown as number,
      benutteVrijstellingen: null as unknown as number,
      totaleVoorwaardelijkeVrijstelling: null as unknown as number,
      totaleBelastbareSchenking: null as unknown as number,
      verschuldigdeSchenkbelasting: null as unknown as number,
      verrekeningOverdrachtsBelasting: null as unknown as number,
      voorkomingDubbeleBelasting: null as unknown as number,
      teBetalenSchenkbelasting: null as unknown as number,
      grondslagConserverendeAanslag: null as unknown as number,
      bedragConserverendeAanslag: null as unknown as number,
      grondslagEersteSchijf: null as unknown as number,
      grondslagTweedeSchijf: null as unknown as number,
      tariefEersteSchijf: null as unknown as number,
      tariefTweedeSchijf: null as unknown as number,
      belastingEersteSchijf: null as unknown as number,
      belastingTweedeSchijf: null as unknown as number,
      verhogingEersteSchijfVanwegeBrutering: null as unknown as number,
      verhogingTweedeSchijfVanwegeBrutering: null as unknown as number,
      totaalBelastingEersteSchijf: null as unknown as number,
      totaalBelastingTweedeSchijf: null as unknown as number,
    })
  }

  ngOnInit(): void {
    this.sbService.getCalculation();
   this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
    })
    this.sbBerekeningSubscription = this.dataService.sbBerekening.subscribe((value: SbBerekening)=> {
      this.sbBerekening = value;
      this.hasOnroerendeZaken = this.dataService.hasOnroerendeZaken.value;
      this.percentageEersteSchijf = value.tariefEersteSchijf != null ? value.tariefEersteSchijf.toFixed(2).toLocaleString() : "0";
      this.percentageTweedeSchijf = value.tariefTweedeSchijf != null ? value.tariefTweedeSchijf.toFixed(2).toLocaleString() : "0";
      this.lengteEersteSchijf = value.grondslagEersteSchijf != null ? value.grondslagEersteSchijf.toLocaleString() : "0";
      this.lengteTweedeSchijf = value.grondslagTweedeSchijf != null ? value.grondslagTweedeSchijf.toLocaleString() : "0";
      this.sbBerekeningFg.patchValue(value,{emitEvent: false})
    })
    this.dataService.aantalValidaties.subscribe((value) => {
      this.aantalValidatiesValue = value;
    });
  }

  ngOnDestroy(): void {
    if (this.sbBerekeningSubscription) {
      this.sbBerekeningSubscription.unsubscribe()
    }
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }
}
